var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("The experiment will launch in fullscreen mode when you click the button below.")]),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.launch()}}},[_vm._v("Launch Experiment")])])}
var staticRenderFns = []

export { render, staticRenderFns }